<mat-select [placeholder]="placeholder" [(ngModel)]="value" [disabled]="disabled" (selectionChange)="onSelect($event)">
  <mat-option *ngFor="let requestDefinition of _requestDefinitions | sort:'name'" [value]="requestDefinition">
    {{ requestDefinition.name }} ({{ requestDefinition.requestDefinitionId }})
  </mat-option>
</mat-select>
